import {
    type ComponentProps,
    type ElementType,
    type HTMLAttributes,
    type PropsWithChildren,
} from "react"
import { Typography, type TypographyProps, Visibility } from "@octopus-energy/coral/atoms"
import { css } from "@octopus-energy/coral-design/css"

type LabelProps = PropsWithChildren<TypographyProps>

function Label({ children, ...props }: LabelProps) {
    return (
        <Typography
            textStyle="h5"
            component="span"
            {...props}
        >
            {children}
            <Visibility
                component="span"
                hidden={{ base: true, md: false }}
            >
                &nbsp;:&nbsp;
            </Visibility>
        </Typography>
    )
}

function Value({ children, ...props }: TypographyProps) {
    return (
        <Typography
            textStyle="body1"
            component="span"
            {...props}
        >
            {children || "Non renseigné(e)"}
        </Typography>
    )
}

const StyledData = (props: HTMLAttributes<HTMLSpanElement> & { centered?: boolean }) => {
    return (
        <span
            className={css({
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                textAlign: props.centered ? "center" : "inherit",
                md: {
                    flexDirection: "row",
                },
            })}
            {...props}
        />
    )
}

type DataProps<TData extends ElementType = typeof StyledData> = PropsWithChildren<
    { as?: TData } & ComponentProps<TData>
>

export function Data<TData extends ElementType = typeof StyledData>({
    children,
    as: Component = StyledData,
    ...props
}: DataProps<TData>) {
    return <Component {...props}>{children}</Component>
}

Data.Label = Label
Data.Value = Value
